import styles from "./GreetingMessages.module.css";
import parse from "html-react-parser";
import { useEffect, useState } from "react";
import { useChatContext } from "../../context/ChatContext";

interface GreetingMessagesProps {
  greetingMessages: string[];
}

const GreetingMessages = ({ greetingMessages }: GreetingMessagesProps) => {
  const { chatSessionStarted, onGreetingAnimationComplete } = useChatContext();
  const greetingBubbles = greetingMessages.map(m => m.trim()).filter(Boolean);
  const [visibleCount, setVisibleCount] = useState(chatSessionStarted ? greetingBubbles.length : 0);

  useEffect(() => {
    if (chatSessionStarted) {
      setVisibleCount(greetingBubbles.length);
    } else {
      setVisibleCount(0);
    }
  }, [greetingBubbles.length, chatSessionStarted]);

  useEffect(() => {
    if (!chatSessionStarted && visibleCount < greetingBubbles.length) {
      const timer = setTimeout(() => setVisibleCount(c => c + 1), 400);
      return () => clearTimeout(timer);
    } else if (!chatSessionStarted && visibleCount === greetingBubbles.length && greetingBubbles.length > 0) {
      onGreetingAnimationComplete?.();
    }
  }, [visibleCount, greetingBubbles.length, chatSessionStarted, onGreetingAnimationComplete]);

  return (
    <>
      {visibleCount > 0 && <p className={`${styles.sender} ${styles.greetingTextVisible}`}>Hjälprobot</p>}
      {greetingBubbles.slice(0, visibleCount).map((text, i) => (
        <p key={i} className={`${styles.greetingText} ${styles.greetingTextVisible}`}>{parse(text)}</p>
      ))}
    </>
  );
};

export default GreetingMessages;